// removed by extract-text-webpack-plugin
module.exports = {"editor":"options-editor__editor___1qn3Y"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/options-editor.css
// module id = 791
// module chunks = 0